import { useMutation } from "urql";

import { CreateCollectionActivityMutationDocument } from "../../../graphql/generated.ts";

export function useCreateCollectionActivity() {
  return useMutation(CreateCollectionActivityMutationDocument);
}
